import { AuthStateLoginStatus } from '../types/auth';

export const isAuthenticated = (status: AuthStateLoginStatus) => {
  //return status === PriceStatus.INIT || status === PriceStatus.LOADING;
  return status === AuthStateLoginStatus.AUTHENTICATED;
};

export const isAuthInitialized = (status: AuthStateLoginStatus) => {
  //return status === PriceStatus.INIT || status === PriceStatus.LOADING;
  return (
    status === AuthStateLoginStatus.AUTHENTICATED ||
    status === AuthStateLoginStatus.NOT_AUTHENTICATED
  );
};
